// React Dependencies
import React from 'react';

// Constants
import { EXPENSE_CONSTANTS, FILTER_CONSTANTS, } from 'AppConstants';

// Utils
import { formatCurrency, getFormattedDate } from 'UtilityComponents/Util';
import { GenericDiv, GenericSpan } from 'commonStyles';
import { StatusCell } from './styles';
// Page Heading
export const PAGE_HEAD_TEXT = 'Travel Budget';

export const textsConfig = {
	PAGE_HEAD_TEXT: 'Travel Budget',
	DASHBOARD_TEXT: 'Dashboard',
	BUDGET_OVERVIEW: 'Budget Overview',
	PAGE_SUB_HEAD_TEXT: 'Monitor and manage travel budget allocations across your organization',
	VIEW_REPORTS: 'VIEW REPORTS',
	EXPORT_DATA: 'EXPORT DATA',
};

// Filter Labels
export const FILTERS_LABEL = {
	BUDGET_NAME: 'Search by Budget Name',
	BUDGET_OWNER: 'Search by Owner Id',
	START_DATE: 'Search by Start Date',
	END_DATE: 'Search by End Date',
};

// Filter Constants
export const BUDGET_FILTERS_CONSTANTS = {
	BUDGET_NAME: 'BUDGET_NAME',
	BUDGET_OWNER: 'BUDGET_OWNER',
	START_DATE: 'START_DATE',
	END_DATE: 'END_DATE'
};

// Filters configuration
export const filters = {
	[BUDGET_FILTERS_CONSTANTS.BUDGET_NAME]: {
		label: FILTERS_LABEL.BUDGET_NAME,
		key: BUDGET_FILTERS_CONSTANTS.BUDGET_NAME,
		filterType: FILTER_CONSTANTS.SEARCH_FILTER,
		value: '',
		filterKey: 'name',
	},
	[BUDGET_FILTERS_CONSTANTS.BUDGET_OWNER]: {
		label: FILTERS_LABEL.BUDGET_OWNER,
		key: BUDGET_FILTERS_CONSTANTS.BUDGET_OWNER,
		type: FILTER_CONSTANTS.CHECKBOX,
		filterType: FILTER_CONSTANTS.TEXT_FILTER,
		value: '',
		filterKey: 'ownerId',
	},
	[BUDGET_FILTERS_CONSTANTS.START_DATE]: {
		label: FILTERS_LABEL.START_DATE,
		key: BUDGET_FILTERS_CONSTANTS.START_DATE,
		filterType: FILTER_CONSTANTS.DATE_FILTER,
		value: '',
		filterKey: 'fromDate',
	},
	[BUDGET_FILTERS_CONSTANTS.END_DATE]: {
		label: FILTERS_LABEL.END_DATE,
		key: BUDGET_FILTERS_CONSTANTS.END_DATE,
		filterType: FILTER_CONSTANTS.DATE_FILTER,
		value: null,
		filterKey: 'toDate',
	},
};

// Budget Table Columns
export const BUDGET_TABLE_COLUMNS = [
	// Will be added later at the time of view report feature
	// {
	// 	header: '',
	// 	accessor: 'budget_id',
	// 	checkBoxColumn: true,
	// },
	{
		header: 'Budget Name',
		accessor: 'name',
		formatter: (value) => <GenericDiv f_weight="700" fsize="14">{value}</GenericDiv>,
	},
	{
		header: 'Period',
		accessor: 'periodicity',
		formatter: (value, row) => (
			<>
				<GenericDiv f_weight="700" fsize="14">{value}</GenericDiv>
				<GenericDiv f_weight="400" fsize="12" color="#757575" top_M="5">
					{getFormattedDate(row?.from_date, EXPENSE_CONSTANTS.DATE_MONTH_FORMAT) }
					<GenericSpan left_M="2" right_M="2" f_weight="400" fsize="12" color="#757575">to</GenericSpan> 
					{getFormattedDate(row?.to_date, EXPENSE_CONSTANTS.DATE_MONTH_FORMAT)}
				</GenericDiv>
			</>
		),
	},
	{
		header: 'Total Budget',
		accessor: 'amount',
		formatter: (value, row) => (
			<>
				<GenericDiv f_weight="700" fsize="14">{formatCurrency(value, true)}</GenericDiv>
			</>
		),
	},
	{
		header: 'Consumed',
		accessor: 'utilisation',
		formatter: (value) => <GenericDiv f_weight="700" fsize="14">{formatCurrency(value?.utilised_amount || 0, true)}</GenericDiv>,
	},
	{
		header: 'Utilisation',
		accessor: 'utilisation',
		formatter: (value) => <GenericDiv f_weight="700" fsize="14">{value?.utilisation_percentage || 0}%</GenericDiv>,
	},
	{
		header: 'Budget Owner',
		accessor: 'owner',
		formatter: (value) => <GenericDiv f_weight="700" fsize="14">{value}</GenericDiv>,
	},
	{
		header: 'Status',
		accessor: 'status_str',
		formatter: (value) => <StatusCell>{value}</StatusCell>,
	},
];

// Table Texts
export const tableTextsConfig = {
	NO_BUDGET_FOUND: 'No Budget Found',
};

// Budget Overview Data
export const BUDGET_OVERVIEW = [
	{ title: 'Total Allocated Budget', key: 'total_amount' },
	{ title: 'Total Consumed Budget', key: 'consumed_amount' },
	{ title: 'Total Available Budget', key: 'available_amount' },
];
